"use client"

import { MessageSquareQuote } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageSquareQuoteIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageSquareQuoteIcon = component(Icon)({
  as: MessageSquareQuote,
})
